import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a02d199"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "InformationHandler" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Запрос в обработке...", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Это может занять некоторое время, данные автоматически обновятся", -1))
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-red-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isInProgress)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_loader, { class: "primary" }),
          _hoisted_2,
          _hoisted_3
        ], 64))
      : (_ctx.isNotFound)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.notFoundMessage), 1))
        : _createCommentVNode("", true)
  ]))
}